Vue.component('companylinks', {
    template: `
        <div>
            <a :href="urls.main" target="_blank" v-if="urls.main">
                {{ $language.linkWeb }}
                <i class="fas fa-globe"></i>
            </a>
            <a v-if="urls.bloomberg" :href="'https://www.bloomberg.com/quote/' + urls.bloomberg" target="_blank">
                Bloomberg&nbsp;<i class="fas fa-globe"></i>
            </a>
            <a v-if="urls.reuters" :href="'https://www.reuters.com/finance/stocks/overview/' + urls.reuters" target="_blank">
                Reuters&nbsp;<i class="fas fa-globe"></i>
            </a>
        </div>
    `,
    props: ['company'],
    data: function() {
        return {
        };
    },
    computed: {

        urls() {

            return this.$store.getters.companyLinks(this.company);

        }

    },

    watch: {
        company: function(newAssignee, oldAssignee) {
            this.onNewCompany();
        }
    },


    mounted: function() {
        this.onNewCompany();
    },

    methods: {
        onNewCompany: function() {

            if (this.company) {
                if (Object.keys(this.urls).length === 0) {

                    axios.get('?page=getData&action=companyLinks', {
                        params: {
                            company: this.company
                        }
                    })
                    .then((response) => {

                        if (response.data[0]) {

                            this.$store.commit('storeLinks', {
                                main: response.data[0].co_url,
                                bloomberg: response.data[0].BBG,
                                reuters: response.data[0].RIC,
                                name: this.company
                            });

                            if (this.urls.main || this.urls.BBG || this.urls.RIC) {

                                this.$emit('fetched_links');
                            }

                        }

                    })
                    .catch((err) => {
                        console.log(err);
                    });
                }
            }
        }

    }
});
